module.exports = __webpack_public_path__ + "static/img/repairs-alterations.4ac2eee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/repairs-alterations.jpg
// module id = Gzd3
// module chunks = 0